export const camelCase = (str) => {
    return str
        .replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
            return index === 0 ? word.toLowerCase() : word.toUpperCase();
        })
        .replace(/\s+/g, '')
        .replace(/-/g, '');
};

export const toString = (value) => {
    return null !== value && undefined !== value ? String(value) : '';
};

export const truncate = (str, length = 130) => {
    return str.length > length ? str.substring(0, length) + '...' : str;
};

export const unquoteSpreadsheetCell = (str) => {
    const isQuoted =
        str.length >= 2 && str.startsWith('"') && str.endsWith('"');

    if (
        !isQuoted ||
        !(str.includes('\n') || str.includes('\t') || str.includes('""'))
    ) {
        return str;
    }

    const inner = str.slice(1, -1);

    if (inner.replaceAll('""', '').includes('"')) {
        return str;
    }

    return inner.replaceAll('""', '"');
};

/**
 * Whether the value can be opened as-is in a new tab: `URL` alone would also
 * accept `javascript:` or `mailto:` values.
 */
export const isHttpUrl = (str) => {
    try {
        return ['http:', 'https:'].includes(new URL(str).protocol);
    } catch {
        return false;
    }
};
